import { StatusTransition } from '../types/interfaces/StatusTransition';

import { ObjectForSelectionTemplate } from './ObjectForSelectionTemplate';

export const StatusTransitionsTemplate: StatusTransition = {
  id: 0,
  name: '',
  priority: 1,
  fromTaskStatus: null,
  toTaskStatus: null,
  fieldFillingControls: [],
  visibleOnMap: true
};
